import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Ferry = t0 => {
  const $ = _c(13);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M1.91992 11.84V11.84C2.14654 11.654 2.473 11.654 2.69961 11.84L3.12522 12.1894C3.55553 12.5426 4.17728 12.5361 4.6001 12.1739L4.6349 12.1441C5.05199 11.7869 5.66915 11.7937 6.07827 12.16V12.16C6.48739 12.5264 7.10455 12.5332 7.52164 12.1759L7.54851 12.1529C7.97378 11.7887 8.60517 11.7922 9.03043 12.1564V12.1564C9.46048 12.5248 10.1032 12.5248 10.5332 12.1564V12.1564C10.9585 11.7922 11.5899 11.7887 12.0151 12.1529V12.1529C12.4476 12.5233 13.0875 12.5163 13.5117 12.1364L13.7453 11.9272C14.0151 11.6857 14.4116 11.6502 14.7199 11.84V11.84" strokeLinecap="round" />;
    t2 = <path d="M1.91992 13.7602V13.7602C2.14654 13.5742 2.473 13.5742 2.69961 13.7602L3.12522 14.1095C3.55553 14.4628 4.17728 14.4563 4.6001 14.0941L4.6349 14.0643C5.05199 13.707 5.66915 13.7138 6.07827 14.0802V14.0802C6.48739 14.4465 7.10455 14.4533 7.52164 14.0961L7.54851 14.0731C7.97378 13.7088 8.60517 13.7124 9.03043 14.0766V14.0766C9.46048 14.4449 10.1032 14.4449 10.5332 14.0766V14.0766C10.9585 13.7124 11.5899 13.7088 12.0151 14.0731V14.0731C12.4476 14.4435 13.0875 14.4364 13.5117 14.0566L13.7453 13.8474C14.0151 13.6058 14.4116 13.5704 14.7199 13.7602V13.7602" strokeLinecap="round" />;
    t3 = <path d="M9.41943 1.39648H9.96925C10.0478 1.39648 10.2049 1.47406 10.2049 1.78436C10.2049 2.09467 10.2049 2.68941 10.2049 2.948" />;
    t4 = <path d="M7.06299 1.39648H6.51317C6.43462 1.39648 6.27753 1.47406 6.27753 1.78436C6.27753 2.09467 6.27753 2.68941 6.27753 2.948" />;
    t5 = <path d="M6.98438 1.39648H9.57638" strokeLinecap="round" />;
    t6 = <path d="M4.23535 6.82685C4.23535 5.87008 4.23535 3.86345 4.23535 3.49109C4.23535 3.11873 4.54953 3.02563 4.70662 3.02563H5.1779H11.383H11.8543C11.9852 3.02563 12.247 3.11873 12.247 3.49109C12.247 3.86345 12.247 5.87008 12.247 6.82685" />;
    t7 = <path d="M12.6651 10.7511L13.4293 7.68014C13.5219 7.30778 13.1512 7.11125 12.9543 7.05952L8.25862 5.92696" strokeLinecap="round" />;
    t8 = <path d="M3.86129 10.7511L3.0971 7.68014C3.00444 7.30778 3.37513 7.11125 3.57206 7.05952L8.26775 5.92696" strokeLinecap="round" />;
    t9 = <path d="M8.25732 5.97339V9.85218" strokeLinecap="round" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] !== props) {
    t10 = <IconWrapper {...props} variant="outline" viewBox="0 0 16 16" strokeWidth={1}>{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}</IconWrapper>;
    $[11] = props;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  return t10;
};
export { Ferry };